import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { DivMain } from './styles'
import toTreeData from './helper/toTreeData'
import LiveEvent from './interface/LiveEvent'
import Table from './components/Table'
import Tabs from './components/Tabs'
import { Layers, Layer } from './app'
import { Event } from './app'
import { MainPropState } from './helper/reducer/getInitialState'
import { layersToArray } from './components/helper/tabs'

interface Props {
    config: {
        showTabs: boolean
        layers: Layers
        showTotal: boolean
    }
    mainInfo: MainPropState
}

interface TableProps {
    [key: number]: {
        data: []
        columns: []
    }
}
function App({ config, mainInfo }: Props): JSX.Element {
    const [tableProps, setTableProps] = useState<TableProps>({
        0: {
            data: [],
            columns: []
        }
    })
    const [selectedLayer, setSelectedLayer] = useState(0)

    useEffect(() => {
        const events = mainInfo?.events || {}
        const eventSpecials = mainInfo?.info?.specials || {}
        const layers = config?.layers || {}
        const datas = Object.entries(layers).reduce((history, [idLayer, valueLayer]: [string, Layer]) => {
            const batch = events[idLayer] || []
            const specials = eventSpecials[idLayer]
            const rows = valueLayer.rows || []
            const columns = valueLayer.columns || []
            const values = valueLayer.values || []
            const showTotal = valueLayer.showTotal || false            
            const [cols, data] = toTreeData(batch, rows, columns, values, specials, showTotal)
            return {
                ...history,
                [parseInt(idLayer)]: { columns: cols, data: data }
            }
        }, {})
        setTableProps(datas)
    }, [config, selectedLayer,mainInfo])    
    return (
        <DivMain>
            <Tabs
                pages={layersToArray(config?.layers)}
                selectedPage={selectedLayer}
                setSelectedPage={setSelectedLayer}
                props={{}}
            />

            {tableProps[selectedLayer]?.data && tableProps[selectedLayer]?.data.length > 0 ? (                
                <Table
                    data={tableProps[selectedLayer]?.data || []}
                    columns={tableProps[selectedLayer]?.columns || []}
                    style={{}}
                />
            ) : null}
        </DivMain>
    )
}

export default connect(props => {
    return { redux: props }
})(App)
